import * as React from "react";
import { Tooltip } from "~/components/Tooltip";

// // // //

// TODO - move this into a utility function somewhere else
function formatDate(date: string): string {
    const dateObj = new Date(date);

    const dateString = dateObj.toLocaleString("en-us", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        timeZone: "utc",
    });
    const timeString = dateObj.toLocaleString("en-us", {
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "shortGeneric",
    });

    return `${dateString} ${timeString}`;
}

/**
 * CreatedAtDisplay
 * Display the ApiKey.createdAt value as both standard and "time-ago" timestamps
 */
export function CreatedAtDisplay(props: {
    createdAt: string;
    createdAtTimeAgo: string;
}) {
    const { createdAt, createdAtTimeAgo } = props;

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                <div className="w-max px-3 py-2 text-center">
                    <p className="whitespace-nowrap text-sm font-light">
                        {formatDate(createdAt)}
                    </p>
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <span
                    ref={setTriggerRef}
                    className="cursor-default text-slate-700 text-sm font-light"
                >
                    {createdAtTimeAgo}
                </span>
            )}
        </Tooltip>
    );
}
